import {Injectable} from '@angular/core';
import {DefaultDataServiceConfig, Logger} from '@ngrx/data';
import {HttpClient} from '@angular/common/http';
import {CustomizeHttpUrlGenerator} from '../../../../../../../store/core/url/customizeHttpUrlGenerator';
import {AbstractDataServiceV2} from '../../../../../../core/service/v2/dataservice/abstractDataServiceV2';
import {MedicalRecordPainModel} from '../../../api/model/medicalRecordPain.model';
import {MedicalRecordPainConverter} from '../../../api/converter/medicalRecordPain.converter';

@Injectable({providedIn: 'root'})
export class MedicalPainDataService
    extends AbstractDataServiceV2<MedicalRecordPainModel, MedicalRecordPainConverter> {
    constructor(http: HttpClient, httpUrlGenerator: CustomizeHttpUrlGenerator,
                logger: Logger, config: DefaultDataServiceConfig,
                converter: MedicalRecordPainConverter) {
        super('MedicalPain', http, httpUrlGenerator, logger, config, converter);
    }
}
